import { render, staticRenderFns } from "./CampaignReward.vue?vue&type=template&id=7d24338a&scoped=true"
import script from "./CampaignReward.vue?vue&type=script&lang=js"
export * from "./CampaignReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d24338a",
  null
  
)

export default component.exports